<template>
  <div class="ask-box">
    <div class="obhh">
    	<!-- onlyMode：锁定套餐类型（如充值中心只能选充值订单），此时隐藏类型选择，只保留该类型下的订单下拉 -->
    	<template v-if="!onlyMode">
	    	<p>套餐类型：</p>
	    	<el-select @change="typeChange('second')" v-model="filters01" placeholder="请选择">
	    		<el-option
	    		  v-for="item in options01"
	    		  :key="item.value"
	    		  :label="item.label"
	    		  :value="item.value">
	    		</el-option>
	    	</el-select>
	    	<p>关联密钥：</p>
    	</template>
    	<el-select v-model="filters02" @change="scretChange" placeholder="请选择">
    		<el-option
    		  v-for="item in options02"
    		  :key="item.value"
    		  :label="item.miyao"
    		  :value="item.value">
    		</el-option>
    	</el-select>
    	<span v-if="scretLabel">{{ifSee?scretLabel:getstr(scretLabel)}}</span>
    	<img v-if="scretLabel" @click="ifSee=!ifSee" :src="ifSee?img1:img2" :alt="ifSee?'隐藏密钥':'显示密钥'"/>
    	<span v-if="onlyMode && queried && !options02.length" class="secret-empty">暂无可选的{{ onlyModeLabel }}订单</span>
    </div>
  </div>
</template>
<script>

  import { orderApi } from '@/api'

  export default {
    name: 'secret',
    // onlyMode：把套餐类型锁死为指定值（1 充值调用 / 2 包天调用 / 3 包年调用），
    // 用于「充值中心」这类只应关联充值订单的入口；不传则维持原有的类型 + 密钥两段选择。
    props: ['eidPop', 'onlyMode'],
	data() {
		return {
			options01: [{
			  value: 1,
			  label: '充值调用'
			}, {
			  value: 2,
			  label: '包天调用'
			}, {
			  value: 3,
			  label: '包年调用'
			}],
			img1: require('../assets/common/ddd.png'),
			img2: require('../assets/common/ddd_.png'),
			options02: [],
			filters01: 1,
			filters02: '',
			orderId: '',
			scretLabel: '',
			ifSee: false,
			firstId: '',
			queried: false
		}
	},
	computed: {
		onlyModeLabel() {
			if (!this.onlyMode) return ''
			const hit = this.options01.filter(item => item.value === Number(this.onlyMode))[0]
			return hit ? hit.label : ''
		}
	},
    methods: {
	  getstr(str) {
		  let newstr = ''
		  for(var i=0;i<str.length;i++) {
			  newstr+='*'
		  }
		  return newstr
	  },
      go_later () {
        this.$emit("childMsg", false);
      },
	  solveArr(arr,time) {
		this.queried = true
		if (!arr || arr.length===0) {
			this.$emit("orderId", '');
			this.options02 = []
			return
		}
	  	let arro= []
	  	arr.forEach((item,index)=>{
	  		let obj = {}
	  		obj['value'] = item.orderId
	  		obj['label'] = item.secret
			obj['miyao'] = '密钥'+(index+1)
	  		arro.push(obj)
			if (this.firstId && time==='first') {
				if (this.firstId===item.orderId) {
					this.scretLabel = item.secret
				}
			}
	  	})
	  	
	  	this.options02 = arro
	  	// 添加
	  	if(arro.length>0) {
			if (time==='first' && this.firstId) {
				this.filters02 = this.firstId
				this.orderId = this.firstId
			} else {
				this.filters02 = arro[0].value
				this.orderId = arro[0].value
				this.scretLabel =  arro[0].label
			}
	  	}
	  	// this.getCase()
		this.$emit("orderId", this.orderId);
	  },
      typeChange(time) {
      	// this.filters01 = ''
      	this.filters02 = ''
      	this.scretLabel = ''
      	this.options02=[]
	  	this.orderId = ''
		// 未登录时不请求密钥（旧实现在此对 undefined 取 userId 会抛错，导致控制台报错）；登录用户请求口径不变
		const user = this.$cookies.getJSON('user')
		if (!user || !user.userId) {
			this.queried = true
			return
		}
		let userId = user.userId || ''
      	let params = {
      		  userId: userId,
      		  billingMode: this.filters01
      	  }
      	orderApi.getSecrets(params)
      	  .then((res) =>{
      		  console.log(res)
      		  if (res.state===200) {
      			
      		  } else {
      			this.$message.error(res.message);
      		  }
      		  if(res.data) {
				this.solveArr(res.data,time)
			  }
      	  })
      	  .catch(err=>{
      		  this.$message.error(err);
      	  })
		  // 锁定类型时不写「上次选择的套餐类型」cookie，避免影响其它页面的记忆
		  if (!this.onlyMode) {
		  	this.$cookies.set('orderType', this.filters01, { expires: 1 })
		  }
      },
	  scretChange(val) {
	  	this.options02.forEach(item=>{
	  		console.log(item.value == val)
	  		console.log(item.value)
	  		console.log(val)
	  		if (item.value === val) {
	  			this.scretLabel = item.label
	  		}
	  		this.orderId = val
	  	})
	  	// console.log(val,label)
	  	// this.orderId = val
	  	// this.getCase()
		this.$emit("orderId", this.orderId);
	  }
    },
	mounted() {
		this.firstId = parseInt(this.$route.query.orderId)
		this.filters01 = this.onlyMode
			? Number(this.onlyMode)
			: (this.firstId ? parseInt(this.$cookies.get('orderType')) : 1)
		this.typeChange('first')
	}
  }
</script>

<style lang="less" scoped>
	.obhh {
		padding: 20px;
		background-color: #fff;
		display: flex;
		align-items: center;
		color: #666666;
		font-size: 14px;
		margin-bottom: 16px;
		p {
			width: 70px;
		}
		.el-select {
			padding-right: 20px;
		}
		span {
			margin-right: 10px;
			width: 250px;
			display: block;
		}
		img {
			width: 14px;
			cursor: pointer;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/secret.vue